import React, { useEffect, useState } from "react";
import { Paper, Group, Text, Progress } from "@mantine/core";
import { IconClock } from "@tabler/icons";

const formatTime = (seconds) => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

const QuizTimerBar = ({
  testDuration,
  startedAt,
  currentIndex,
  totalQuestions,
  onExpire,
}) => {
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    if (!testDuration || testDuration <= 0 || !startedAt) {
      setRemaining(null);
      return;
    }

    const endTime =
      new Date(startedAt).getTime() + testDuration * 60 * 1000;

    const tick = () => {
      const left = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      setRemaining(left);
      if (left <= 0) onExpire?.();
    };

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [testDuration, startedAt, onExpire]);

  if (!testDuration || testDuration <= 0) {
    return (
      <Paper p="sm" withBorder radius={0} sx={{ position: "sticky", top: 0, zIndex: 100 }}>
        <Text size="sm">
          Question {currentIndex + 1} of {totalQuestions}
        </Text>
      </Paper>
    );
  }

  const low = remaining !== null && remaining <= 300;

  return (
    <Paper
      p="sm"
      withBorder
      radius={0}
      sx={{ position: "sticky", top: 0, zIndex: 100 }}
    >
      <Group position="apart">
        <Group spacing="xs">
          <IconClock size={18} color={low ? "red" : undefined} />
          <Text size="sm" weight={600} color={low ? "red" : undefined}>
            Time Remaining: {remaining !== null ? formatTime(remaining) : "--"}
          </Text>
        </Group>
        <Text size="sm">
          Question {currentIndex + 1} of {totalQuestions}
        </Text>
      </Group>
      <Progress
        mt="xs"
        value={
          remaining !== null
            ? (remaining / (testDuration * 60)) * 100
            : 100
        }
        color={low ? "red" : "blue"}
        size="sm"
      />
    </Paper>
  );
};

export default QuizTimerBar;
